import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Async thunk to fetch gallery images from the API
export const fetchGalleryImages = createAsyncThunk(
    'gallery/fetchGalleryImages',
    async () => {
          // Fetch the baseURL from config.json
       const configResponse = await fetch('/config.json');
       const config = await configResponse.json();
       const baseURL = config.baseURL || process.env.REACT_APP_BASE_URL;
        const response = await axiosInstance.get('/api/Common/GetGallery', {
            headers: {
                accept: 'application/json',
            },
        });

        // Slice the images to limit the number, e.g., first 5 images
        return response.data.message.slice(0, 5).map((image) => ({
            src: `${baseURL}/Upload${image}`,
            alt: 'Gallery Image', 
        }));
    }
);

// Gallery slice
const gallerySlice = createSlice({
    name: 'gallery',
    initialState: {
        images: [],
        status: 'idle', // Can be 'loading', 'succeeded', or 'failed'
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGalleryImages.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGalleryImages.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.images = action.payload;
            })
            .addCase(fetchGalleryImages.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

export default gallerySlice.reducer;
